<template>
  <div>
    <div v-if="!schedules || !schedules.length" class="tw-text-muted tw-text-sm">
      No schedule configured for this source.
    </div>
    <div v-else class="schedule-cards">
      <div
        v-for="row in rows"
        :key="row.key"
        class="schedule-card"
        :class="{ 'is-muted': row.enabled === false }"
      >
        <div class="schedule-label">{{ row.label }}</div>
        <div class="schedule-next">
          <DisplayDatetimeCron
            v-if="row.schedule"
            :cron-schedule="row.schedule"
          />
          <span v-else class="tw-text-muted">—</span>
        </div>
        <div class="schedule-cron">
          <CronStrings
            v-if="row.schedule"
            :cron-strings="row.schedule.cronStrings"
            :enabled="row.schedule.enabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CronStrings from './CronStrings'
import DisplayDatetimeCron from './DisplayDatetimeCron'

export default {
  props: {
    schedules: Array,
  },
  components: {
    CronStrings,
    DisplayDatetimeCron,
  },
  computed: {
    first() {
      return (this.schedules && this.schedules[0]) || null
    },
    rows() {
      if (!this.first) return []
      return [
        { key: 'sync', label: 'Sync', schedule: this.first.sync, enabled: this.first.sync && this.first.sync.enabled },
        { key: 'purge', label: 'Purge', schedule: this.first.purge, enabled: this.first.purge && this.first.purge.enabled },
        { key: 'reconcile', label: 'Reconcile', schedule: this.first.reconcile, enabled: this.first.reconcile && this.first.reconcile.enabled },
      ]
    },
  },
}
</script>

<style scoped>
.schedule-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.schedule-card {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 0.85rem;
  background: #fafafa;
}

.schedule-card.is-muted {
  opacity: 0.55;
}

.schedule-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #71717a;
  margin-bottom: 0.35rem;
}

.schedule-next {
  font-weight: 600;
  color: #18181b;
  margin-bottom: 0.45rem;
}

.schedule-cron {
  font-size: 0.8rem;
  color: #52525b;
}

@media (max-width: 800px) {
  .schedule-cards {
    grid-template-columns: 1fr;
  }
}
</style>
